import { render, staticRenderFns } from "./DynamicPriceRangeSlider.vue?vue&type=template&id=4f4c0115&scoped=true"
import script from "./DynamicPriceRangeSlider.vue?vue&type=script&lang=js"
export * from "./DynamicPriceRangeSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4c0115",
  null
  
)

export default component.exports